<div class="px-2 h-[auto] mb-10">
	<app-main-header
		><h1 class="text-lg md:text-3xl mb-[10px] ml-[10px]">
			<span class="text-accentColor"> {{ title() }}</span
			><span class="text-mainColor"> {{ titleSuffix() }}</span>
		</h1>
	</app-main-header>
	@let offerList = offerList$ | async;
	@if (!!offerList?.length && !!offerList) {
		<swiper [config]="swiperConfig">
			@for (offer of offerList; track offer.product.id; let i = $index) {
				<ng-template swiperSlide>
					<app-offer-box-mobile-highlight
						class="flex items-center justify-center"
						[offer]="offer"
					></app-offer-box-mobile-highlight>
				</ng-template>
			}
		</swiper>
	} @else {
		<app-main-loader></app-main-loader>
	}
</div>
